import {StrictMode} from 'react';
import {createRoot} from 'react-dom/client';
import App from './App.tsx';
import './i18n';
import './index.css';
import AppAppearance from './components/AppAppearance';
import { AuthProvider } from './contexts/AuthContext';
import { BrowserRouter } from 'react-router-dom';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <AppAppearance>
        <BrowserRouter>
          <AuthProvider><App /></AuthProvider>
        </BrowserRouter>
    </AppAppearance>
  </StrictMode>,
);
